export default __webpack_public_path__ + "static/media/customRole.dbc7bf25.png";